import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { DensityStyleTypes } from '../../../../types'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { renderColorByString } from 'components/DataGrid/renderColorByString'

interface OrgStatusCellProps {
  params: GridRenderCellParams
  densityStyles: DensityStyleTypes
}

const OrganizationStatusCell: FC<OrgStatusCellProps> = ({ params, densityStyles }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'center',
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
        color: renderColorByString(params?.value),
      }}
    >
      <Typography
        noWrap
        variant="body2"
        sx={{
          fontSize: densityStyles.fontSize,
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {params.value}
      </Typography>
    </Box>
  )
}
export default OrganizationStatusCell
